<template>
  
  <div>
    <shopping-cart :key="'eventshoppingcart'+$route.params.id">
    </shopping-cart>
  
  </div>

</template>

<script>
  export default {

    created:function(){

        let order = this.$route.params.order;
        if(!order){
          // TODO - removendo se recuperamos do localstorage
          this.$store.commit("OrderStore/clearOrder");
        }
    },
    beforeRouteUpdate (to, from, next) {
        let order = to.params.order;
        if(!order){
          // TODO - removendo se recuperamos do localstorage
          this.$store.commit("OrderStore/clearOrder");
        }
      next()
    },


    watch: {
      $route: function(val,old) {
        // 
        // console.log(val)
        if( val.params.order != old.params.order && val.params.order == undefined ){
            window.location.reload();
        }
      },
    }


  }
</script>

<style>

</style>
